module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-creative-07.bef7f226.jpg";